import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { environment } from '@env';
import { NbSidebarService } from '@nebular/theme';
import { NotificationMenuComponent } from '@notifications/components/notification-menu/notification-menu.component';
import { IUserProfile } from '@shared/interfaces/user/user-profile';
import { BrowserService } from '@shared/services/browser.service';
import { UserService } from '@shared/modules/account/services/user.service';
import { WindowService } from '@shared/services/window.service';
import { Subscription } from 'rxjs';
import { ApiService } from '@shared/services/api.service';
import { DeviceNotificationService } from '@notifications/services/device-notification.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss']
})
export class NavMenuComponent implements OnInit, OnDestroy {
  @ViewChild("notificationsMenu") notificationsMenu!: NotificationMenuComponent;
  @ViewChild("contextMenu") contextMenu!: ElementRef;
  private subscriptions: Subscription = new Subscription();

  currentUser: IUserProfile | null = null;
  numberOfNotifications: number = 0;
  isMobile: boolean = false;
  baseAvatarUrl: string = environment.inCloud.baseUrl;
  hideBadge = false;

  constructor(
    private sidebarService: NbSidebarService,
    private browserService: BrowserService,
    private windowService: WindowService,
    private userService: UserService,
    private api: ApiService,
    private deviceNotificationService: DeviceNotificationService
  ) { }

  ngOnInit(): void {
    this.subscriptions.add(
      this.userService.user$.subscribe(user => {
        this.currentUser = user;
      })
    );

    this.getCountNotifications();
    this.subscriptions.add(this.browserService.screenSizeChanged(900).subscribe(res => this.isMobile = res));

    this.subscriptions.add(this.deviceNotificationService.unreadDeviceNotificationCount$.subscribe((res: number) => {
      this.hideBadge = res === 0;
      this.numberOfNotifications = res;
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  toggleSideMenu() {
    this.sidebarService.toggle(false, "left");
  }

  getCountNotifications() {
    this.subscriptions.add(this.api.getUnreadUserDeviceNotificationsCount().subscribe(res => {
      this.hideBadge = res === 0;
      this.numberOfNotifications = res;
    }));
  }

  openRobozeMainPage(){
    this.windowService.blankOpen(environment.roboze.url);
  }

  toggleNotificationsMenu() {
    this.contextMenu.nativeElement.classList.remove("show");
    this.hideBadge = true;
    this.notificationsMenu.toggleNotificationsMenu();
  }

  isPro(): boolean {
    return this.currentUser?.package == "Pandora Pro";
  }
}
